import APIClient from '@/shared/http/clients/api'

const resourceName = 'transferencia-auto-card'
const APICore = process.env.APIBaseURLCore

const Create = (boardColumnId = {}, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/board/${boardColumnId}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const TransfAutoCardRepository = {
  Create,
  Update
}

export default TransfAutoCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/transferenciaAutoCard.js